export default __webpack_public_path__ + "static/media/Frame 3214mobile.80472dff.png";